import React from 'react';
import { useTranslation } from 'react-i18next';
import { DeviationResourceType } from '../../types/deviation';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { BiData } from '@wix/da-bi/pkg/events';
const EditTierButton = ({ className, onClick, isOwner, tier })=>{
    var _tier_tier;
    const { t } = useTranslation();
    if (!isOwner) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(GhostButton, {
        className: className,
        size: "medium",
        variant: "edit-purple",
        onClick: (e)=>{
            e.stopPropagation();
            onClick();
        },
        biData: BiData({
            evid: 536,
            typeid: DeviationResourceType.TIER,
            itemid: tier.deviationId
        }),
        disabled: [
            'deleted',
            'pending_deletion'
        ].includes(((_tier_tier = tier.tier) === null || _tier_tier === void 0 ? void 0 : _tier_tier.state) || '')
    }, t('deviationview.tierCard.cta.edit'));
};
EditTierButton.displayName = 'EditTierButton';
export default EditTierButton;

//# sourceMappingURL=EditTierButton.js.map